import React from "react";
import { Helmet } from "react-helmet";

import Button from "../components/button/Button";
import pageNotFoundIllustration from "../images/page-not-found-illustration.svg";

const PageNotFound = () => (
  <>
    <Helmet
      htmlAttributes={{
        lang: "en",
      }}
    >
      <title>404 - Page not found</title>
    </Helmet>
    <main className="pageNotFound">
      <section className="pageNotFound__contentContainer">
        <div class="pageNotFound__imageContainer">
          <img
            src={pageNotFoundIllustration}
            className="pageNotFound__image"
            alt="404 - Page not found"
          />
        </div>
        <h1 className="pageNotFound__title">Page not found</h1>
        <p className="pageNotFound__description">
          The page you're looking for appears to have been moved, deleted, or
          doesn't exist. We apologize for the inconveniences.
        </p>
        <Button to="/" primary noIcon className="pageNotFound__link">
          Go to home page
        </Button>
      </section>
    </main>
  </>
);

export default PageNotFound;
